import { EditorState } from 'draft-js';

export const getCurrentColor = (editorState: EditorState) => {
  let color = '#000';
  const currentStyle = editorState.getCurrentInlineStyle();
  const stylesArray = currentStyle.toArray();

  stylesArray.forEach((s: string) => {
    const match = s.match(/^CUSTOM_COLOR_(.+)$/);

    if (match) {
      color = match[1];
    }
  });

  return color;
};
